/**
 * スタッフの作成 / 更新。レコード整形は record.ts に委譲する。
 *
 * 作成は login_id/password の有無で経路が分かれる:
 * - あり: create-staff-user Edge Function（認証ユーザー付きで原子的に作成）。
 * - なし: 通常の Repository insert（認証ユーザーは作らない）。
 */
import type { AuthScope } from "@/usecase/shared/authScope";
import type { StaffDeps } from "./deps";
import {
  buildCreateStaffUserBody,
  buildStaffInsert,
  buildStaffPatch,
  type CreateStaffValues,
  type UpdateStaffValues,
} from "./record";

export async function createStaff(
  values: CreateStaffValues,
  scope: AuthScope,
  deps: StaffDeps,
): Promise<unknown> {
  const shopId = scope.shopId ?? "";

  if (values.login_id && values.password) {
    return deps.gateway.createStaffUser(
      buildCreateStaffUserBody(
        { ...values, login_id: values.login_id, password: values.password },
        shopId,
      ),
    );
  }

  const [row] = await deps.repository("staff").create(buildStaffInsert(values, shopId));
  return row;
}

export async function updateStaff(
  { id, ...values }: UpdateStaffValues & { id: string },
  deps: StaffDeps,
): Promise<unknown> {
  const [row] = await deps
    .repository("staff")
    .update({ id, patch: buildStaffPatch(values) });
  return row;
}
